module.exports = __webpack_public_path__ + "img/food_csboomcsboom.cc03787.png";